<template>
  <NConfigProvider
    :theme-overrides="themeOverrides.overrides"
    :breakpoints="breakpoints"
    :locale="naiveLocale?.locale"
    :date-locale="naiveLocale?.dateLocale"
    inline-theme-disabled
  >
    <NGlobalStyle />
    <NEl class="naive-css-variables">
      <NLoadingBarProvider>
        <NDialogProvider>
          <NNotificationProvider>
            <NMessageProvider :max="2" :duration="15000" closable>
              <NaiveWindowProvider />
              <ThemeProvider />
              <slot />
            </NMessageProvider>
          </NNotificationProvider>
        </NDialogProvider>
      </NLoadingBarProvider>
    </NEl>
  </NConfigProvider>
</template>

<script setup lang="ts">
import { breakpoints } from '@/plugins/naive-ui/shared'
import { naiveLocale } from '@/plugins/i18n'
import { useDialog, useLoadingBar, useMessage, useNotification, useThemeVars } from 'naive-ui'
import { useThemeOverrides, useThemeStore } from '@/store'
import { watch } from 'vue'

defineOptions({
  name: 'NaiveProvider',
})

// exposes the Naive UI providers on `window` so they can be used outside of components
const NaiveWindowProvider = () => {
  window.$dialog = useDialog()
  window.$message = useMessage()
  window.$notification = useNotification()
  window.$loadingBar = useLoadingBar()

  return undefined
}

const ThemeProvider = () => {
  const themeStore = useThemeStore()
  const themeVars = useThemeVars()

  // get theme from localStorage or set light by default
  const theme = (localStorage.getItem('theme') as TCaplenaTheme) || 'light'

  watch(
    themeVars,
    (newVal) => {
      themeStore.themeVars = newVal
    },
    { immediate: true }
  )

  themeStore.setThemeWithName(theme)

  return undefined
}

const themeOverrides = useThemeOverrides()
</script>

<style lang="scss" scoped>
.n-config-provider,
.naive-css-variables {
  height: 100%;
  width: 100%;
}
</style>
